export default __webpack_public_path__ + "static/spoon-faa3b8e2f4346a8a2552b5df99581e6a.png";